const ADVICE = {
    global: [
        'Some enemies have an elemental weakness. Try to exploit those with the right spells and weapons.',
        'If an enemy deals too much damage with an elemental attack, try to find something to raise your respective resistance.',
    ],
    lost: [
        'Always make sure, you are using the best units for each battle. Recruit new units or check if new recruits are better suited for the task at hand.',
        'You will often get useful equipment after battles. Check your squad for possible improvements every now and then.',
        'If you want to take down one enemy first, you can focus attacks on it by selecting it.',
        'Some enemies deal more damage than others. Try to focus your attacks on those first.',
        'If you can\'t beat a certain enemy, try searching in old and cleared regions for some stuff to get better equipment.',
    ],
}

export default ADVICE
